const routes = [
  {
    path: "/",
    redirect: '/pc-hearing',
   // beforeEnter: beforeEnterIndex
  },
  {
    name: "404",
    path: "/404",
    component: () => import("../view/not-find/index.vue")
  },
  //web端听力
  {
    path: "/pc-hearing",
    name: "pcHearing",
    component: () => import("../view/pc-hearing/index.vue"),
    meta: {
      title: "听力课堂"
    }
  },
  //web端听力
  {
    path: "/pc-hearing/:id",
    name: "pcHearingDetail",
    component: () => import("../view/pc-hearing/components/detail.vue"),
    meta: {
      title: "听力课堂"
    }
  },
  //web端听力
  {
    path: "/pc-feedback",
    name: "pcFeedBack",
    component: () => import("../view/pc-feedback/index.vue"),
    meta: {
      title: "意见反馈"
    }
  },
  {
    path: "*",
    redirect: "/404"
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/routes.js